import moment from 'moment'

export const date_filters = {
    data() {
        return {
        }
    },
    mounted() {
    },
    filters: {
        // reformats a date using moment.js
        relative_datetime(input) {
            let datetimetext = moment(String(input)).format('HH:mm, D MMM YYYY')
            let fromnow = moment(String(input)).fromNow()
            return fromnow + ", " + datetimetext
        },
        relative_day(input) {
            // return blank if input is blank
            if (!input) {
                return ''
            }

            let date_time_text = moment(String(input)).format('D MMM YYYY')
            let fromnow = moment(String(input)).fromNow()
            return fromnow + ", " + date_time_text
        },
        relative_day_in_weeks(input) {
            // return blank if input is blank
            if (!input) {
                return ''
            }
            // init variable to return
            let result

            // Get input date as nice text
            let datetimetext = moment(String(input)).format('D MMM YYYY')

            //get todays date
            let today = moment()

            //get birth date
            let end_date = moment(String(input))
            let weeks = end_date.diff(today, 'week')
            let days = end_date.diff(today, 'day') % 7

            // skip empty
            if (Math.abs(weeks) < 1) {
                result = Math.abs(days) + ' days'
            }
            else {
                result = Math.abs(weeks) + ' weeks, ' + Math.abs(days) + ' days'
            }

            if (weeks < 0 ) {
                result = 'Ended'
            }

            result += ', ' + datetimetext
            return result
        }
    }
}
